import React, { useEffect, useRef, useState } from "react";

import { useIsClientSide } from "@utils/hooks/isClient.hook";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";

import { InfoBlockHeading } from "../infoBlockHeading/infoBlockHeading.component";
import "./description.scss";

type DescriptionProps = {
    product: FullProductApiModel;
};

const Description = ({ product }: DescriptionProps) => {
    const { t } = useGranite();
    const isClientSide = useIsClientSide();
    const [showLessButton, setShowLessButton] = useState(false);
    const [showTruncation, setShowTruncation] = useState(false);
    const [showMobileMore, setShowMobileMore] = useState(false);
    const textWrapper = useRef<HTMLDivElement>(null);
    const dotRef = useRef<any>(null);

    useEffect(() => {
        if (isClientSide) {
            import("dotdotdot-js").then(mod => {
                if (textWrapper.current) {
                    dotRef.current = new mod.default(textWrapper.current, {
                        callback: (isTruncated: boolean) => {
                            if (isTruncated) {
                                setShowTruncation(true);
                            }
                        },
                        ellipsis: "\u2026 ",
                        truncate: "word",
                        watch: "window",
                    });
                }
            });
        }
    }, [isClientSide, textWrapper.current]);

    useEffect(() => {
        if (showLessButton) {
            dotRef.current?.restore();
            dotRef.current?.unwatch();
        } else {
            dotRef.current?.truncate();
            dotRef.current?.watch();
        }
    }, [showLessButton]);

    return (
        <section
            className={`info-block js-info-block js-anchor-scroll-spy__block ${
                showMobileMore ? "info-block--active" : ""
            }`}
        >
            <InfoBlockHeading
                title={t("productDetail.anchor.title.description")}
                onClick={() => setShowMobileMore(state => !state)}
            />
            <section className="info-block__content">
                <div className="row">
                    <div className="col-12">
                        <span
                            id={t("productDetail.anchor.hash.description")}
                            className="anchor-span"
                        ></span>
                        <h4 className="title mb-3 font-weight-bold anchor--pdp-info-nav      ">
                            <span
                                className="title__content"
                                data-test="titleComponent-Omschrijving"
                            >
                                {t("productDetail.anchor.title.description")}
                            </span>
                        </h4>

                        <div className="description-component mb-3">
                            <div
                                className="description-component__content ddd-truncated"
                                ref={textWrapper}
                                style={{
                                    overflowWrap: "break-word",
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: `<p>${product.description}</p>`,
                                }}
                            ></div>
                            <div className="description-component__button-holder">
                                {showTruncation && (
                                    <Button
                                        type="button"
                                        color="link"
                                        className="p-0"
                                        onClick={() =>
                                            setShowLessButton(state => !state)
                                        }
                                    >
                                        {showLessButton
                                            ? t(
                                                  "productDetail.description.link.showLess",
                                              )
                                            : t(
                                                  "productDetail.description.link.showMore",
                                              )}{" "}
                                        <i
                                            className={`las la-angle-${
                                                showLessButton ? "up" : "down"
                                            } ml-1`}
                                        ></i>
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
};

export { Description };
